/* eslint-disable consistent-return, react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useRef } from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

import Blocks from '../blocks/Blocks';
import CareerSection from '../partials/CareerSection';

import styles from '../../../styles/pages/gym.module.scss';

const propTypes = {
    page: AppPropTypes.page.isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const GymPage = ({ page, className }) => {
    const internshipRef = useRef(null);
    const { blocks = null, careerSections: sections = [] } = page || {};
    const withSections = sections !== null && sections.length > 0;

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.content}>
                {withSections ? (
                    <div ref={internshipRef} id="internship">
                        {(sections || []).map((section, idx) => (
                            <CareerSection
                                key={`career-section-${idx + 1}`}
                                item={section}
                                isPageHeader={idx === 0}
                            />
                        ))}
                    </div>
                ) : null}
                {blocks !== null ? (
                    <Blocks
                        className={styles.blocks}
                        blocks={blocks}
                        isContainer
                        typeClassName={{
                            title: styles.title,
                        }}
                    />
                ) : null}
            </div>
        </div>
    );
};

GymPage.propTypes = propTypes;
GymPage.defaultProps = defaultProps;

export default GymPage;
